var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { PasswordService } from './password.service';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { BaseComponent } from '../base/base.component';
var PasswordComponent = /** @class */ (function (_super) {
    __extends(PasswordComponent, _super);
    function PasswordComponent(router, route, logger, message, page, passwordService) {
        var _this = _super.call(this, router, route, logger, message, page, passwordService) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.message = message;
        _this.page = page;
        _this.passwordService = passwordService;
        _this.model = {};
        _this.loading = false;
        return _this;
    }
    PasswordComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    PasswordComponent.prototype.password = function () {
        var _this = this;
        if (this.model.new_password !== this.model.confirm_password) {
            return;
        }
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.passwordService.password(this.model)
            .subscribe(function (data) {
            if (data === null) {
                return;
            }
            _this.router.navigate(['/top']);
        }, function (error) {
            _this.loading = false;
        });
    };
    PasswordComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    template: "<pa-header [navBtn]=\"false\" [unit]=\"false\"></pa-header>\n<div class=\"l-login\">\n  <main role=\"main\" class=\"main\">\n    <alertblock></alertblock>\n    <div class=\"login\">\n      <form class=\"login_form\" (ngSubmit)=\"f.form.valid && password()\" #f=\"ngForm\" novalidate>\n        <dl>\n          <dt>\n            <label for=\"current_password\">{{ (msg | async)['PasswordComponent.label.currentPassword'] }}</label>\n          </dt>\n          <dd>\n            <input type=\"password\" id=\"current_password\" name=\"current_password\" [(ngModel)]=\"model.current_password\" #current_password=\"ngModel\" required/>\n            <p *ngIf=\"f.submitted && !current_password.valid\" class=\"login_form_comment\">{{ (msg | async)['PasswordComponent.error.currentPassword'] }}</p>\n          </dd>\n          <dt>\n            <label for=\"new_password\">{{ (msg | async)['PasswordComponent.label.newPassword'] }}</label>\n          </dt>\n          <dd>\n            <input type=\"password\" id=\"new_password\" name=\"new_password\" [(ngModel)]=\"model.new_password\" #new_password=\"ngModel\" required/>\n            <p *ngIf=\"f.submitted && !new_password.valid\" class=\"login_form_comment\">{{ (msg | async)['PasswordComponent.error.newPassword'] }}</p>\n          </dd>\n          <dt>\n            <label for=\"confirm_password\" style=\"white-space: pre-wrap;\">{{ (msg | async)['PasswordComponent.label.confirmPassword'] }}</label>\n          </dt>\n          <dd>\n            <input type=\"password\" id=\"confirm_password\" name=\"confirm_password\" [(ngModel)]=\"model.confirm_password\" #confirm_password=\"ngModel\" required/>\n            <p *ngIf=\"f.submitted && !confirm_password.valid\" class=\"login_form_comment\">{{ (msg | async)['PasswordComponent.error.confirmPassword'] }}</p>\n            <p *ngIf=\"new_password.valid && confirm_password.valid && new_password.value !== confirm_password.value\" class=\"login_form_comment\">{{ (msg | async)['PasswordComponent.error.notMatch'] }}</p>\n          </dd>\n        </dl>\n        <button [disabled]=\"loading\" type=\"submit\">{{ (msg | async)['PasswordComponent.button.changePassword'] }}</button>\n      </form>\n      <div class=\"login_description\">\n        <div class=\"login_description_listWrapper\" [innerHTML]=\"(msg | async)['PasswordComponent.note']\"></div>\n      </div>\n    </div>\n  </main>\n  <pa-footer></pa-footer>\n</div><!-- /.l-login -->\n<loading></loading>\n"
                }] }
    ];
    /** @nocollapse */
    PasswordComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: MessageService },
        { type: PageService },
        { type: PasswordService }
    ]; };
    return PasswordComponent;
}(BaseComponent));
export { PasswordComponent };
//# sourceMappingURL=password.component.js.map